var banners = {
    init: function () {
        window.dataLayer = window.dataLayer || [];

        var elements = document.querySelectorAll('[data-banner]');

        let options = {
            rootMargin: '0px',
            threshold: 1.0,
        };

        this.observer = new IntersectionObserver(this.impressed, options);

        elements.forEach((element) => {
            let bannerName = element.getAttribute('data-banner');
            this.observer.observe(element);

            element.addEventListener('click', (e) => {
                let data = {
                    event: 'BannerClicked',
                    bannerName: bannerName,
                    url: window.location.href,
                };

                dataLayer.push(data);
            });
        });
    },
    impressed: function (entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let element = entry.target;
                let bannerName = element.getAttribute('data-banner');

                let data = {
                    event: 'BannerImpressed',
                    bannerName: bannerName,
                    url: window.location.href,
                };

                dataLayer.push( data );
                observer.unobserve(element);
            }
        });
    },
};

export { banners };
